import React from 'react'
import { List, Button, Menu, Item } from 'semantic-ui-react'
import TimeAgo from 'timeago-react'
import _ from 'lodash'
import { MAIN, DISABLED } from '../config/constants'


const renderItem = (item, index, selected, onSelectHandler) => {
    //console.log(item)
    const { email, date_created } = item.data
    const date = new Date(date_created)
    const active = index===selected?true:false
    const hasDiagnosis = _.has(item.data, 'diagnosis')
    //console.log(index + ": selected" + selected + " = " + active)
    return (
        <Item key={index} onClick={() => onSelectHandler(index)} style={{backgroundColor: active?MAIN:null}}>
            <Item.Content style={{padding: 5}}>
                <Item.Header as={!active?'a':null} 
                    style={{color: active?'white':MAIN, fontWeight:'bold'}}>
                    <span style={{fontWeight: 'bold'}}>
                        {email}
                    </span>    
                </Item.Header>
                <Item.Description as={!active?'a':null} style={{fontWeight: hasDiagnosis?null:'bold'}}><TimeAgo datetime={date} /></Item.Description>
            </Item.Content>
        </Item>
    )
}

const _renderFooter = (loading, lastPage, requestMoreData) => {
    let footer = ''

    // if (loading) {
    //     footer = 
    //         <Spinner color={MAIN} />
    // } else {
        if (lastPage){
            footer =
                <span style={{color: DISABLED}}>Plant Hospital</span>
        } else {
            footer =
                <Button style={{justifyContent: 'center'}} onClick={() => requestMoreData()}>
                    <span style={{color: MAIN}}>Load More</span>
                </Button>
        }
    
    
    return (
        <Item  key={'last'} style={{justifyContent: 'center'}}>
            <Item.Content style={{padding: 10, alignItems: 'center'}}>
                {footer}
            </Item.Content>
            
        </Item>
    )
}

const RequestList = (props) => {
    const { requestList, selected, onSelectHandler, lastPage, loading, requestMoreData } = props
    //console.log("list: ", requestList)
    
    return (

        <List divided animated style={{ overflow: 'scroll'}}>
            {requestList.map((request, index) => renderItem(request, index, selected, onSelectHandler))}
            {_renderFooter(loading, lastPage, requestMoreData)}
        </List>
    )
}

export default RequestList